export default __webpack_public_path__ + "static/media/Ballroll_00083.8db81738.png";